<template>
  <div class="text-field">
    <input
      :maxlength="maxlength"
      v-on:input="updateValue($event.target.value)"
      class="input"
      :type="type"
      :placeholder="placeholder"
    />
    <div v-if="error !== ''" class="error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "text"
    },
    error: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    maxlength: {
      type: String,
      default: ""
    }
  },
  methods: {
    updateValue: function(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss" scoped>
::placeholder {
  color: #696969;
  font-family: "SFProText-Medium", -apple-system;
  font-weight: 500;
}
.text-field {
  margin-bottom: 20px;
}
.input {
  width: 100%;
  border-radius: 5px;
  border: 1px solid #eeeeee;
  background-color: #fafafa;
  height: 50px;
  font-size: 16px;
  font-family: "SFProText-Medium" -apple-system;
  font-weight: 500;
  outline: none;
  outline-style: none;
  padding: 0 20px;
  box-shadow: none;
}
.error {
  color: red;
  margin-top: 8px;
  font-family: "SFProText-Medium" -apple-system;
  font-weight: 500;
  text-align: left;
}
</style>